import { useEffect, useRef, useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Features } from './components/Features';
import { HowItWorks } from './components/HowItWorks';
import { UseCases } from './components/UseCases';
import { PlansContact } from './components/PlansContact';
import { Footer } from './components/Footer';

export const LandingPage = () => {
  const [showHeader, setShowHeader] = useState(false);
  const ctaRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    const cta = ctaRef.current;
    if (!cta) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Show header when CTA is NOT intersecting (scrolled past)
        setShowHeader(!entry.isIntersecting);
      },
      {
        threshold: 0,
        rootMargin: '-80px 0px 0px 0px', // Trigger slightly before fully out
      }
    );

    observer.observe(cta);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen w-full bg-white font-sans antialiased overflow-x-hidden">
      {/* Subtle background gradient for depth */}
      <div className="fixed inset-0 bg-gradient-to-br from-blue-50/40 via-white to-rose-50/30 pointer-events-none" />

      <Header visible={showHeader} />

      <div className="relative">
        <Hero ctaRef={ctaRef} />
        <PainPoints />
        <Features />
        <HowItWorks />
        <UseCases />
        <PlansContact />
        <Footer />
      </div>
    </div>
  );
};
